/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.import-patient-data-dialog {
  .MuiPaper-root {
    max-width: 650px;
    width: 650px;
  }

  .property-table {
    height: 100%;
    width: 100%;

    .name-cell {
      border: none;
      color: variables.$color-black-60;
      width: 33%;
    }

    .property-cell {
      border: none;
      width: 33%;

      .empty-text {
        color: variables.$color-disabled;
      }
    }
  }
}
